import React from 'react';

import { VnoDrawerContent } from '../GetAssetDrawers';
import { useAccountModalStore } from './useAccountModalStore';

function AccountModalDrawerContentsZksync() {
  const openDrawer = useAccountModalStore((s) => s.openDrawer);

  return <>{openDrawer === 'vno' && <VnoDrawerContent />}</>;
}

export default AccountModalDrawerContentsZksync;
